import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TAddShopifyAppRequest,
	TInstallShopifyStoreRequest,
	TShopifyAppsRequest,
	TShopifyAppsResponsePayload,
	TShopifyAppsStore,
	TShopifyStoresRequest,
	TShopifyStoresResponsePayload,
} from './types';

// ==========================================:
export const initialState: TShopifyAppsStore = {
	shopifyApps: null,
	shopifyAppsLoader: false,
	shopifyStores: null,
	shopifyStoresLoader: false,
	addShopifyAppLoader: false,
	installShopifyStoreLoader: false,
};

// ==========================================:
const shopifyApps = createSlice({
	name: '@@shopifyApps',
	initialState,
	reducers: {
		getShopifyAppsRequest: (
			state: TShopifyAppsStore,
			action: PayloadAction<TShopifyAppsRequest>,
		) => {
			const shopifyAppsState = state;
			shopifyAppsState.shopifyAppsLoader = true;
		},
		getShopifyAppsSuccess: (
			state: TShopifyAppsStore,
			action: PayloadAction<TShopifyAppsResponsePayload>,
		) => {
			const { payload } = action;
			const shopifyAppsState = state;
			shopifyAppsState.shopifyApps = payload;
			shopifyAppsState.shopifyAppsLoader = false;
		},
		getShopifyStoresRequest: (
			state: TShopifyAppsStore,
			action: PayloadAction<TShopifyStoresRequest>,
		) => {
			const shopifyAppsState = state;
			shopifyAppsState.shopifyStoresLoader = true;
		},
		getShopifyStoresSuccess: (
			state: TShopifyAppsStore,
			action: PayloadAction<TShopifyStoresResponsePayload>,
		) => {
			const { payload } = action;
			const shopifyAppsState = state;
			shopifyAppsState.shopifyStores = payload;
			shopifyAppsState.shopifyStoresLoader = false;
		},
		resetShopifyStores: (state: TShopifyAppsStore) => {
			const shopifyAppsState = state;
			shopifyAppsState.shopifyStores = null;
			shopifyAppsState.shopifyStoresLoader = false;
		},
		addShopifyAppRequest: (
			state: TShopifyAppsStore,
			action: PayloadAction<TAddShopifyAppRequest>,
		) => {
			const shopifyAppsState = state;
			shopifyAppsState.addShopifyAppLoader = true;
		},
		addShopifyAppSuccess: (state: TShopifyAppsStore) => {
			const shopifyAppsState = state;
			shopifyAppsState.addShopifyAppLoader = false;
		},
		installShopifyStoreRequest: (
			state: TShopifyAppsStore,
			action: PayloadAction<TInstallShopifyStoreRequest>,
		) => {
			const shopifyAppsState = state;
			shopifyAppsState.installShopifyStoreLoader = true;
		},
		installShopifyStoreSuccess: (state: TShopifyAppsStore) => {
			const shopifyAppsState = state;
			shopifyAppsState.installShopifyStoreLoader = false;
		},
		shopifyAppsInitState: () => initialState,
	},
});

export default shopifyApps.reducer;
export const {
	getShopifyAppsRequest,
	getShopifyAppsSuccess,
	getShopifyStoresRequest,
	getShopifyStoresSuccess,
	resetShopifyStores,
	addShopifyAppRequest,
	addShopifyAppSuccess,
	installShopifyStoreRequest,
	installShopifyStoreSuccess,
	shopifyAppsInitState,
} = shopifyApps.actions;
